export const environment = {
  API_BASE_URL: "https://api.gauswarn.com",
  // API_BASE_URL: "https://085a-106-222-217-16.ngrok-free.app",

  // API_BASE_URL: "https://api.gauswarn.com",
  // https://97ca-106-222-215-59.ngrok-free.app/admin/getAllSales,
  SHIPPING_API_URL :'https://shipping-api.com'
};
